import React from "react";
import Modal from "react-responsive-modal";

const styles = {
  fontFamily: "sans-serif",
  textAlign: "center"
};

export default class  Popup extends React.Component {
  constructor(props) {
        super(props);
        this.state = { open: false };
    }
  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  render() {
    const { open } = this.state;
	const Wrapper = this.props.content.component;
    return (
      <div style={styles}>
        <button className="btn" onClick={this.onOpenModal}>Click here to calculate your maintenance calories</button>
        <Modal open={open} onClose={this.onCloseModal}>
		
		<h2>{this.props.content.heading}</h2>
		
		<Wrapper></Wrapper>
		
		<p dangerouslySetInnerHTML={{__html: this.props.content.info}} />
		
		  
        </Modal>
      </div>
    );
  }
}